import * as angular from "angular";
import {IController} from "angular";


//TODO WARNING> this component was a angularjs directive and was use at the market (deprecated)

export class RouteActionMenuCtrl implements IController {
  route: any;
  isSuggestion: any;
  onRefresh: Function;

  constructor() {
  }

   openAssignDialog(ev) {
    // this.routesDialogService.openAssignDialog(ev,this.route.serviceIdList,this.route.rid,assignToDriver);
     // event, serviceIdList, rid, assignToDriver

      // return $mdDialog.show({
      //   template: '<service-assign-dialog flex layout="column" ids="ids" on-assign="assignToDriver" route-id="routeId"></service-assign-dialog>',
      //   parent: angular.element(document.body),
      //   scope: _.assign($scope.$new(), {ids: $scope.route.serviceIdList, routeId: $scope.route.rid}),
      //   targetEvent: ev
      // })
  }

   openRemoveDialog(ev) {
    // Ask user to confirm deleting route
    // var id = _.get($scope, 'route.rid'); // Route id to delete
    // var title = 'Remove Route';
    // var text = 'Are you sure you want to remove route #' + id;
    // var success = 'Route #' + id + ' removed successfully'
    //
    // var objRef = this.$route(id);
    // objRef.$lock();
    // return ConfirmDialog.confirm(title, text, ev).then(function () {
    //   // When dialog is confirmed, call delete, this is unusual, but required by API
    //   return objRef.$delete()
    //     .then(function () {
    //       $mdToast.show(
    //         $mdToast.simple()
    //           .textContent(success));
    //       objRef.$unlock();
    //       // Refresh entity
    //       $scope.onRefresh();
    //     });
    // }, function () {
    //   objRef.$unlock();
    //   $scope.onRefresh();
    // });
  };


   moveToMarket(event) {
    // var text = 'Are you sure you want to Move To Market?';
    // ConfirmDialog.confirm('Confirm Move To Market', text, event).then(
    //   function () {
    //     var routeCopy = angular.copy($scope.route);
    //     _.set(routeCopy, 'status', 'InMarket');
    //     $route($scope.route.rid).$post(routeCopy).then(
    //       function (updatedRoute) {
    //         $scope.route = updatedRoute;
    //       },
    //       function (error) {
    //         $log.error('Failed to update route ' +
    //           'routeActionMenu@moveToMarket' + error)
    //       }
    //     )
    //   },
    //   function () {
    //     $log.info('Dialog Closed')
    //   }
    // )
  }



}

angular
  .module('bringoz.admin.routes')
  .component('routeActionMenu', {
    bindings: {
      route: '<',
      isSuggestion: '<?',
      onRefresh: '&'
    },
    template: require('./route-action-menu.html').default,
    controller: RouteActionMenuCtrl
  });


